export default ({...props}) => {
  const {size, space, unit} = props.theme
  return `
    & > div.MuiBox-root.map-wrapper {
        & > div {
            height: calc(${unit(80)}vh - ${size(39.375)}px);
            max-height: ${size(40)}px;

            @media screen and (max-width: 501px) {
                height: calc(${unit(100)}vh - ${size(39.375)}px);
            }

            @media screen and (max-width: 376px) {
                height: calc(${unit(100)}vh - ${size(40.625)}px);
            }

            @media screen and (max-width: 321px) {
                height: calc(${unit(100)}vh - ${size(48.75)}px);
            }
        }
    }
    & > div[ap_atom_name="apContactDetailsWrapperAtom"] {
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
    }
    & > div.MuiBox-root.button-wrapper{
        display: flex;
        gap: ${space(2)}px;

        @media screen and (max-width:321px){
            flex-flow: column;
        }

        & button {
            text-transform: capitalize;
        }
    }
    & div.address-details-wrapper {
        width: ${unit(100)}%;
    }
    `
}
